<script setup lang="ts">


</script>

<template>

    <div>
        <div class="mx-auto text-center my-16">

            <img src="@/assets/images/OrderHealthMonitor/carbucks-coming-soon-image-001.png" class="mx-auto mb-6 pl-6">

            <h1 class="mb-8">
                <div class="text-4xl font-semibold">Available to order soon</div>
                <div class="text-lg font-semibold">(Or you can pick one up now from a participating Dealership)</div>
            </h1>
            <p class="px-6 max-w-xl mx-auto text-lg">
                Just like a <br class="inline lg:hidden" /><span class="text-primary-600 uppercase font-bold">Fitbit for your car</span>,<br class="inline lg:hidden" /> our Vehicle Health Monitor 
                provides real-time insights into your car's performance and health, 
                when paired with the <span class="text-primary-600 uppercase font-bold">Carbucks App.</span>
            </p>
        </div>

    </div>

</template>